import { Tabs } from "antd";
import { listHooks } from "../../hooks/handlers/registerHooks";
import { TListHook } from "../../@types/common";
import { BottomSheetTitle } from "../elements/Elements";

export const TabView = ({ ...rest }: any) => {
  const { source, dismiss, title } = rest || {};
  const hook = listHooks?.[source];
  const { detailsTabs }: TListHook = hook ? hook() : {};
  return (
    <div className="p15">
      {/* TITLE */}
      <BottomSheetTitle dismiss={dismiss}>{title}</BottomSheetTitle>
      <Tabs items={detailsTabs({ ...rest })} />
    </div>
  );
};
